import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'
import Box from '@mui/material/Box'

const NODE_ENV = process.env.NODE_ENV
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID

const Page = ({ title, children, ...rest }) => {
  const router = useLocation()

  useEffect(() => {
    if (NODE_ENV !== 'production') {
      return
    }
    if (!router?.pathname) {
      return
    }

    if (window.gtag) {
      // eslint-disable-next-line camelcase
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: router.pathname, // eslint-disable-line camelcase
        page_name: title // eslint-disable-line camelcase
      })
    }
  }, [title, router?.pathname])

  const isUAT = window.location.href.includes('toyotafleetapp.bornuat1.co.nz') ||
                window.location.href.includes('uat.toyotafleet.app')
  const isDev = window.location.href.includes('dev-sites')
  const isLocal = window.location.href.includes('local')
  const isDemo = window.location.href.includes('demo')

  const environmentTag =
    isLocal || isDev || isUAT || isDemo
      ? `[${isLocal ? 'LOCAL' : isDev ? 'DEV' : isUAT ? 'UAT' : 'DEMO'}] `
      : ''

  return (
    <Box {...rest}>
      <Helmet>
        <title>{environmentTag}Toyota Fleet Portal - {title}</title>
      </Helmet>
      {children}
    </Box>
  )
}

Page.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string
}

export default Page
